import { space } from "skin/event";

export default function bill() {
	const o = {
		type: 'table',
		title: 'Пополнение',
		data: {
			code: 'bill',
		},
	};
	space(o, true);
	return true;
}